import React from 'react'
import { MonitoringStatus } from 'enum/monitoring-status.enum'
import styles from './ProgressBarStateCourse.module.scss'

interface Props {
  advance: MonitoringStatus
  progress: number
}

const colors: Record<MonitoringStatus, string> = {
  [MonitoringStatus.InProgress]: '#FFC400',
  [MonitoringStatus.Pending]: '#EC5B56',
  [MonitoringStatus.Finish]: '#36B37E',
}

export const ProgressBarStateCourse: React.FC<Props> = ({
  advance,
  progress,
}) => {
  const color = colors[advance || MonitoringStatus.Pending]

  const percent = progress

  return (
    <div className={styles.backgroundProgressBar}>
      <div
        className={styles.fillerProgressBar}
        style={{
          width: `${percent}%`,
          minWidth: '10px',
          backgroundColor: color || '',
        }}
      ></div>
    </div>
  )
}

export default ProgressBarStateCourse
